import React, { useState, useEffect, useRef } from 'react';
import { etkinlikArr } from './EtkinliklerData';
import PageTitle from '../pagetitle/PageTitle';
import { Card, CardImg } from 'reactstrap';

const Speakers = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [popupSrc, setPopupSrc] = useState(null);
  const popupRef = useRef(null);

  const filterSpeakersBySearch = (speaker) => {
    const searchRegex = new RegExp(searchTerm, 'i');
    return searchRegex.test(speaker.date) || searchRegex.test(speaker.title);
  };

  const showPopup = (src) => {
    setPopupSrc(src);
  };

  const hidePopup = () => {
    setPopupSrc(null);
  };

  const searchSpeaker = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleOutsideClick = (e) => {
    if (popupRef.current && !popupRef.current.contains(e.target)) {
      hidePopup();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <>
      <PageTitle name="Etkinlikler" />
      <div className='container konusmacilarAll'>
        <div className="row">
          <div className='col-md-12'>
            <div className='row'>
              {etkinlikArr
                .filter(filterSpeakersBySearch)
                .map((speaker, index) => (
                  <div className="col-md-4 my-3" key={index}>
                    <Card hall={speaker?.hall} title={speaker?.title}>
                      <CardImg src={speaker.src} onClick={() => showPopup(speaker.src)} />
                    </Card>
                  </div>
                ))
              }
            </div>
          </div>
        </div>
      </div>

      {popupSrc && (
        <div className="popup" onClick={hidePopup} ref={popupRef}>
          <div className="popupCont">
            <div className="figure">
                <span className="kapat" onClick={hidePopup}><i className="bi bi-x-lg"></i></span>
              <img src={popupSrc} alt="Popup Image" />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Speakers;
